import React, {useState, useEffect} from 'react';
import IconLike from './icons/like-toggle.svg';
import * as styles from './merkliste.module.scss';

const MerklisteMenuButton = () => {

    const [showButton, setShowButton] = useState(false);
    const [productCount, setProductCount] = useState(0);

    const checkStorage = () => {
        setShowButton(JSON.parse(localStorage.getItem('likedProducts'))?.length > 0);
        setProductCount(JSON.parse(localStorage.getItem('likedProducts'))?.length);
    };

    useEffect(() => {
        checkStorage();
        window.addEventListener('storage', checkStorage);
        return () => window.removeEventListener('storage', checkStorage);
    }, []);

    return (<>
            {showButton && <a className={styles.toggle} href={'/pages/merkliste'} aria-label={'Meine Merkliste'}
                              title={"Meine Merkliste"}>
                <IconLike/>
                {productCount > 0 && <span className={'cart-count-bubble'}>
                    <span>{productCount}</span>
                </span>}
            </a>}
        </>
    );
}

export default MerklisteMenuButton;